export default [
  {
    'id': 1,
    'title': 'Start',
    'type': '',
    'path': '/{citySlug}',
  },
  {
    'id': 2,
    'title': 'Restauranger',
    'type': null,
    'path': '/restauranger/{citySlug}',
  },
  {
    'id': 3,
    'title': 'Guider',
    'type': 'guides',
    'path': '/guider/{citySlug}',
  },
  {
    'id': 4,
    'title': 'Artiklar',
    'type': 'articles',
    'path': '/artiklar/{citySlug}',
  },
  {
    'id': 5,
    'title': 'Evenemang',
    'type': null,
    'path': '/evenemang/{citySlug}',
  },
  {
    'id': 6,
    'title': 'Erbjudanden',
    'type': null,
    'path': '/erbjudanden/{citySlug}',
  },
  {
    'id': 7,
    'title': 'Stora sällskap',
    'type': null,
    'path': '/bokningsforfragan',
  },
  {
    'id': 8,
    'title': 'Presentkort',
    'type': null,
    'path': '/presentkort/{citySlug}',
  },
  {
    'id': 9,
    'title': 'Appen',
    'type': '',
    'path': '/appen',
  },
]
